export default "__VITE_ASSET__fa5e82cb__"